module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aupKh"))).then(() => parcelRequire('hEqeo'));